import _extends from "@babel/runtime/helpers/esm/extends";
import _classCallCheck from "@babel/runtime/helpers/esm/classCallCheck";
import _createClass from "@babel/runtime/helpers/esm/createClass";
import _assertThisInitialized from "@babel/runtime/helpers/esm/assertThisInitialized";
import _inherits from "@babel/runtime/helpers/esm/inherits";
import _possibleConstructorReturn from "@babel/runtime/helpers/esm/possibleConstructorReturn";
import _getPrototypeOf from "@babel/runtime/helpers/esm/getPrototypeOf";
import _defineProperty from "@babel/runtime/helpers/esm/defineProperty";

function _createSuper(Derived) { var hasNativeReflectConstruct = _isNativeReflectConstruct(); return function _createSuperInternal() { var Super = _getPrototypeOf(Derived), result; if (hasNativeReflectConstruct) { var NewTarget = _getPrototypeOf(this).constructor; result = Reflect.construct(Super, arguments, NewTarget); } else { result = Super.apply(this, arguments); } return _possibleConstructorReturn(this, result); }; }

function _isNativeReflectConstruct() { if (typeof Reflect === "undefined" || !Reflect.construct) return false; if (Reflect.construct.sham) return false; if (typeof Proxy === "function") return true; try { Boolean.prototype.valueOf.call(Reflect.construct(Boolean, [], function () {})); return true; } catch (e) { return false; } }

import React from "react";
import { getRehydratableName, getClassNameFactory } from "../../../../utilities";
import classNames from "classnames";
import ChevronDownIcon from "@dcl/icons/esm/ui/chevron-down";
import ChevronUpIcon from "@dcl/icons/esm/ui/chevron-up";
import SmallRightIcon from "@dcl/icons/esm/ui/small-right";
import Panel from "../Panel";
import { BASE_FONT_SIZE, MENU_PADDING_LEFT } from "./MenuConstants";

var Menu = /*#__PURE__*/function (_React$Component) {
  _inherits(Menu, _React$Component);

  var _super = _createSuper(Menu);

  function Menu() {
    var _this;

    _classCallCheck(this, Menu);

    for (var _len = arguments.length, args = new Array(_len), _key = 0; _key < _len; _key++) {
      args[_key] = arguments[_key];
    }

    _this = _super.call.apply(_super, [this].concat(args));

    _defineProperty(_assertThisInitialized(_this), "menuRef", void 0);

    _defineProperty(_assertThisInitialized(_this), "linkRef", void 0);

    _defineProperty(_assertThisInitialized(_this), "menuChildrenRef", void 0);

    _defineProperty(_assertThisInitialized(_this), "componentDidMount", function () {
      window.addEventListener("click", _this.handleDocumentClick);
      window.addEventListener("keydown", _this.handleKeypress);
    });

    _defineProperty(_assertThisInitialized(_this), "componentWillUnmount", function () {
      window.removeEventListener("click", _this.handleDocumentClick);
      window.removeEventListener("keydown", _this.handleKeypress);
    });

    _defineProperty(_assertThisInitialized(_this), "componentDidUpdate", function () {
      var _assertThisInitialize = _assertThisInitialized(_this),
          menuRef = _assertThisInitialize.menuRef,
          menuChildrenRef = _assertThisInitialize.menuChildrenRef,
          expanded = _assertThisInitialize.props.expanded;

      if (!expanded) {
        return;
      }
      /*
       * Position open Menu children relative to their parent.
       */


      var menuOffsetLeft = menuRef.offsetLeft - MENU_PADDING_LEFT;

      if (menuChildrenRef.offsetLeft > menuOffsetLeft) {
        menuChildrenRef.style.marginLeft = "".concat(menuOffsetLeft / BASE_FONT_SIZE, "rem");
      }
    });

    _defineProperty(_assertThisInitialized(_this), "handleDocumentClick", function (evt) {
      var siteHeaderViewportWidth = 1200;

      if (window.innerWidth < siteHeaderViewportWidth) {
        return;
      }

      var menusContainer = _this.getMenusContainer(evt);

      var wasClickedInsideThisMenu = _this.wasClickedInsideThisMenu(evt, menusContainer);

      var wasClickedInADifferentMenu = _this.wasClickedInADifferentMenu(evt, menusContainer);

      if (wasClickedInsideThisMenu || wasClickedInADifferentMenu) {
        return;
      }

      _this.props.setOpenMenu(null);
    });

    _defineProperty(_assertThisInitialized(_this), "handleItemClick", function (e) {
      e.preventDefault();
      e.stopPropagation();

      if (_this.props.expanded) {
        _this.props.setOpenMenu(null);
      } else {
        _this.props.setOpenMenu(_this.props.title);
      }
    });

    _defineProperty(_assertThisInitialized(_this), "getMenusContainer", function (evt) {
      var getClassName = getClassNameFactory("SiteHeader");
      var menusContainerClassName = getClassName({
        descendantName: "menus"
      });

      var menusContainer = _this.getClosestMenuContainer(evt.target, ".".concat(menusContainerClassName));

      return menusContainer;
    });

    _defineProperty(_assertThisInitialized(_this), "getClosestMenuContainer", function (elem, selector) {
      var childElem = elem;

      while (childElem) {
        childElem = childElem.parentNode;

        if (childElem === document) {
          return null;
        }

        if (childElem && childElem.matches(selector)) {
          return childElem;
        }
      }

      return null;
    });

    _defineProperty(_assertThisInitialized(_this), "wasClickedInsideThisMenu", function (evt, menusContainer) {
      var clickedInsideMenu = menusContainer && (_this.menuChildrenRef.contains(evt.target) || _this.linkRef.contains(evt.target));

      return clickedInsideMenu;
    });

    _defineProperty(_assertThisInitialized(_this), "wasClickedInADifferentMenu", function (evt, menusContainer) {
      var clickedInsideAdifferentMenu = menusContainer && !_this.menuRef.contains(evt.target) && evt.target !== menusContainer;
      return clickedInsideAdifferentMenu;
    });

    _defineProperty(_assertThisInitialized(_this), "handleRegisterRef", function (refName) {
      return function (ref) {
        if (ref) {
          _this[refName] = ref;
        }
      };
    });

    _defineProperty(_assertThisInitialized(_this), "handleFocus", function (evt) {
      if (!evt.currentTarget.classList.contains("is-expanded")) {
        _this.props.setOpenMenu(null);
      }
    });

    _defineProperty(_assertThisInitialized(_this), "handleKeypress", function (evt) {
      if (evt.key === "Escape") {
        _this.props.setOpenMenu(null);
      } else if (evt.key === "Tab") {
        setTimeout(function () {
          var _document$activeEleme;

          if (((_document$activeEleme = document.activeElement) === null || _document$activeEleme === void 0 ? void 0 : _document$activeEleme.closest(".tr-SiteHeaderMenu")) === null) {
            _this.props.setOpenMenu(null);
          }
        }, 100);
      }
    });

    return _this;
  }

  _createClass(Menu, [{
    key: "render",
    value: function render() {
      var getClassName = getClassNameFactory("SiteHeaderMenu");
      var _this$props = this.props,
          children = _this$props.children,
          expanded = _this$props.expanded,
          fallbackHref = _this$props.fallbackHref,
          href = _this$props.href,
          title = _this$props.title,
          ariaLabel = _this$props.ariaLabel;
      var anchorProps = {}; // Optionally apply props based on href and fallbackHref

      if (href) {
        anchorProps.href = href;
      } else {
        anchorProps.onClick = this.handleItemClick;
        anchorProps.role = "button";
        anchorProps["aria-haspopup"] = true;
        anchorProps["aria-expanded"] = expanded;

        if (fallbackHref) {
          anchorProps.href = fallbackHref;
        } else {
          anchorProps.href = "#";
        }
      }

      return /*#__PURE__*/React.createElement("li", {
        className: getClassName({
          modifiers: classNames({
            href: href
          }),
          states: classNames({
            expanded: expanded
          })
        }),
        ref: this.handleRegisterRef("menuRef"),
        "data-rehydratable": getRehydratableName(Menu.displayName),
        "data-fallback-href": fallbackHref,
        "data-href": href,
        "data-title": title,
        "data-aria-label": ariaLabel,
        onFocus: this.handleFocus
      }, /*#__PURE__*/React.createElement("a", _extends({
        className: getClassName({
          descendantName: "link"
        }),
        "aria-label": ariaLabel,
        ref: this.handleRegisterRef("linkRef")
      }, anchorProps), /*#__PURE__*/React.createElement("span", {
        className: getClassName({
          descendantName: "linkText"
        })
      }, title), /*#__PURE__*/React.createElement("div", {
        className: getClassName({
          descendantName: "linkIcon"
        })
      }, expanded ? /*#__PURE__*/React.createElement(ChevronUpIcon, null) : /*#__PURE__*/React.createElement(ChevronDownIcon, null)), /*#__PURE__*/React.createElement("div", {
        className: getClassName({
          descendantName: "narrowLinkIcon"
        })
      }, /*#__PURE__*/React.createElement(SmallRightIcon, {
        width: 24
      }))), /*#__PURE__*/React.createElement("div", {
        tabIndex: -1,
        className: getClassName({
          descendantName: "content"
        })
      }, /*#__PURE__*/React.createElement(Panel, {
        title: title,
        open: expanded,
        onBack: this.handleItemClick
      }, /*#__PURE__*/React.createElement("div", {
        className: getClassName({
          descendantName: "children"
        }),
        ref: this.handleRegisterRef("menuChildrenRef")
      }, children))));
    }
  }]);

  return Menu;
}(React.Component);

_defineProperty(Menu, "displayName", "SiteHeader.Menu");

_defineProperty(Menu, "defaultProps", {
  expanded: false,

  /**
   * these are provided by `handleSiteHeaderChildren
   * */
  setOpenMenu: function setOpenMenu() {},
  currentMenu: null
});

export default Menu;